<template>
    <v-autocomplete
        v-model="condition"
        v-bind="$attrs"
        :items="conditions"
        :aria-required="required"
        :disabled="disabled"
        hideDetails="auto"
        itemText="label"
        itemValue="value"
        dense
        outlined
    />
</template>

<script>
export default {
    name: 'DropdownCondition',
    props: {
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            conditions: [
                {
                    label: 'New',
                    value: 'NEW',
                },
                {
                    label: 'Used',
                    value: 'USED',
                },
            ],
        };
    },
    computed: {
        condition: {
            get() {
                return this.value;
            },
            set( value ) {
                this.$emit( 'input', value );
            },
        },
    },
};
</script>
